import { Navigate } from "react-router-dom";
import { ROLES } from "../config/Roles.config";

// Authentication
import Login from "../pages/Authentication/Login";
import Onboarding from "../pages/Authentication/Onboarding";

// User Profile and related pages
import UserProfile from "../pages/UserProfile/UserProfile"
import FAQ from "../pages/UserProfile/components/FAQ";
import Testimonial from "../pages/UserProfile/components/Testimonial";
import ContactUs from "../pages/UserProfile/components/ContactUs/ContactUs";

// Screens or Pages
import Dashboard from "../pages/Dashboard/Dashboard";
import Podcast from "../pages/Podcast/Podcast";
import DevotionalNews from "../pages/DevotionalNews/DevotionalNews";
import EducationalContent from "../pages/EducationalContent/EducationalContent";
import EducationalChapters from "../pages/EducationalContent/components/EducationalChapters";
import BhaktiSangeet from "../pages/BhaktiSangeet/BhaktiSangeet";
import InformationSection from "../pages/InformationSection/InformationSection";
import EBooksSection from "../pages/EBooksSection/EBooksSection";
import MagazinePage from "../pages/Magazine/MagazinePage";
import MCQManagement from "../pages/MCQManagement/MCQManagement";
import FavoriteSection from "../pages/FavoriteSection/FavoriteSection";
import HinduCalenderOrPanchang from "../pages/HinduCalender/HinduCalenderOrPanchang";
import HinduCalendar from "../pages/HinduCalender/HinduCalendar";
import DailyChallenges from "../pages/DailyChallenges/DailyChallenges";
import WordCompletionGame from "../pages/DailyChallenges/components/WordCompletionGame/WordCompletionGame";
import PrivacyPolicy from "../pages/UserProfile/components/Privacy/PrivacyPolicy";
import DeleteAccountInstruction from "../pages/UserProfile/components/DeleteAccountInstruction/DeleteAccountInstruction";

// Common routes for all the user
export const CommonRoutes = [
  {
    path: "/*",
    element: <Navigate to="/" replace />,
    roles: [ROLES.ADMIN, ROLES.USER],
  },
];

// Secure routes according to dynamic user role
export const SecureRoutes = [
  {
    path: "/",
    element: <Dashboard />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: false,
    subHeaderTitle: "",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/profile",
    element: <UserProfile />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: false,
    subHeaderTitle: "",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/faq",
    element: <FAQ />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "FAQ",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "Contact Us",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/testimonial",
    element: <Testimonial />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "Testimonial",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "Privacy Policy",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/delete-account-instruction",
    element: <DeleteAccountInstruction />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "Delete Account Instructions",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/podcast",
    element: <Podcast />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "Podcast",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/bhakti-sangeet",
    element: <BhaktiSangeet />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "Bhakti Sangeet",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/educational-topics",
    element: <EducationalContent />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "Educational Topics",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/educational-chapters",
    element: <EducationalChapters />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "Chapters",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/devotional-news",
    element: <DevotionalNews />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "Devotional News",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/information-section",
    element: <InformationSection />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "Information Section",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/e-books",
    element: <EBooksSection />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "E-Books",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/magazine",
    element: <MagazinePage />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: false,
    subHeaderTitle: "Magazine",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/quiz",
    element: <MCQManagement />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "Quiz",
    isSearchBarVisible: false,
    showBackButton: false,
  },
  {
    path: "/favorite",
    element: <FavoriteSection />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: true,
    subHeaderTitle: "Favorites",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/hindu-calender",
    element: <HinduCalendar />,
    // Restricted to all users, for now.
    // No plan is purchased for Calender API.
    roles: [],
    isSubHeaderVisible: false,
    subHeaderTitle: "",
    isSearchBarVisible: false,
    showBackButton: true,
  },
  {
    path: "/daily-challenge",
    element: <DailyChallenges />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: false,
    subHeaderTitle: "",
    isSearchBarVisible: false,
    showBackButton: false,
  },
  {
    path: "/daily-challenge/word-completion",
    element: <WordCompletionGame />,
    roles: [ROLES.ADMIN, ROLES.USER],
    isSubHeaderVisible: false,
    subHeaderTitle: "",
    isSearchBarVisible: false,
    showBackButton: false,
  },
  ...CommonRoutes,
];

// Public routes
export const PublicRoutes = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/onboarding",
    element: <Onboarding />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/delete-account-instruction",
    element: <DeleteAccountInstruction />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  ...CommonRoutes,
];